import { memo } from "react"
import {Routes,Route, Link} from 'react-router-dom';
import { FaChevronRight as RightIcon} from "react-icons/fa";
import {
  DocumentUpload,
  ExamSetUp,ExamSubject,ExamTimeTable,FeeSetUp,
  PermissionSetUp,GradeScore,ExamPeriod,PhotocardDownload,StudyCenter, DocUpload, Suspend, PromotionCond, TranscriptAmount, StudentMigration,UpgradeScore,LevelSetUp,
  LookUpSetUp,
  EmailTemplate,
  WitholdExam,
  DeletedTimeTable,
  SubscriptionSetUp,
  TranscriptTemplateUpdate, 
} from './';
import {Box,Card,Grid, GridItem, Image, Flex, Circle} from '@chakra-ui/react';
import { TopDisplay } from "../../../components";
import ResetUser from "./ResetUser/ResetUser";
import RescheduleExam from "./RescheduleExam.tsx/RescheduleExam";
import SpecialFees from "./SpecialFees/SpecialFees";
import ExamInstructionsEditor from "./ExamInstructionsEditor/ExamInstructionsEditor";
import PhotocardPeriodSetUp from "./PhotocardPeriodSetUp/PhotocardPeriodSetUp";
import ResitTimeTable from "./ResitTimeTable/ResitTimeTable";
import RolePermission from "./RolePermission/RolePermission";

const Settings = () => {
  return (
    <Routes>
      <Route path="/" element={<DefaultSettings />}/>
      {/* <Route path="/admin-role" element={<AdminRole/>} />
      <Route path="/admin-user" element={<AdminUser />}/> */}
      <Route path="/resit-time-table" element={<ResitTimeTable />}/>
      <Route path="/subscription-set-up" element={<SubscriptionSetUp />}/>
      <Route path="/document-upload" element={<DocumentUpload/>}  />
      <Route path="/doc-upload" element={<DocUpload/>}  />
      <Route path="/exam-instructions-editor" element={<ExamInstructionsEditor />} />
      <Route path="/exam-setup" element={<ExamSetUp />} />
      <Route path="/exam-subject" element={<ExamSubject />} />
      <Route path="/exam-time-table" element={<ExamTimeTable />} />
      <Route path="/fee-setup" element={<FeeSetUp />} />
      <Route path="/permission-setup" element={<PermissionSetUp/>} />
      <Route path="/grade-score" element={<GradeScore />} />
      <Route path="/photocard-period-setup" element={<PhotocardPeriodSetUp />} />
      <Route path="/photocard-download" element={<PhotocardDownload/>} />
      <Route path="/study-center" element={<StudyCenter />} />
      <Route path="/exam-period" element={<ExamPeriod />} />
      <Route path="/reset-user" element={<ResetUser />} />
      <Route path="/reschedule-exam" element={<RescheduleExam />} />
      <Route path="/suspend" element={<Suspend />} />
      <Route path="/special-fees" element={<SpecialFees />} />
      <Route path="/transcript-amount" element={<TranscriptAmount />} />
      <Route path="/promotion-cond" element={<PromotionCond />} />
      <Route path="/student-migration" element={<StudentMigration />} />
      <Route path="/upgrade-Score" element={<UpgradeScore />} />
      <Route path="/level-setup" element={<LevelSetUp />} />
      <Route path="/withold-exam" element={<WitholdExam />} />
      <Route path="/deleted-time-table" element={<DeletedTimeTable />} />
      <Route path="/look-up-setup" element={<LookUpSetUp />} />
      <Route path="/role-permission" element={<RolePermission />} />
      <Route path="/email-template" element={<EmailTemplate/>} />
      <Route path="/transcript-template-update" element={<TranscriptTemplateUpdate/>} />


    </Routes>
  )
}

export default memo(Settings);

type ListType = {
  id:number;
  name:string;
  path:string;
  color?:string;
}
const DefaultSettings = () =>{
  const settings_list:ListType[] = [
    {
      id:1,
      name: 'Exemptiom Levels SetUp',
      path: "level-setup",
      color: "#DEA22F"
    },
    {
      id:2,
      name: 'Email Template SetUp',
      path: "email-template",
      color: "#035752"
    },
    {
      id:3,
      name:'Study Center SetUp',
      path:"study-center",
      color:"#967BB6"
    },
    {
      id:4,
      name:'Grade Score SetUp',
      path:"grade-score",
      color:"#191970"
    },
    {
      id:5,
      name:'Document Type SetUp',
      path:"document-upload",
      color:'#191970'
    },
    {
      id:5,
      name:'Documents Upload',
      path:"doc-upload",
      color:'#191970'
    },
    {
      id:6,
      name: 'examDeferment Lookup %.',
      path: "look-up-setup",
      color: "#035752"
    },
    {
      id:7,
      name:'Special Fees SetUp',
      path:"special-fees",
      color:"#DEA22F"
    },
    {
      id:8,
      name:'Exam Subject SetUp',
      path:"exam-subject",
      color:"#035752"
    },
    {
      id:9,
      name: 'Promotion Condition SetUp',
      path: "promotion-cond",
      color: "#035752"
    },
    {
      id:10,
      name:'Exam Diet(Period) SetUp',
      path:"exam-period",
      color:"#967BB6"
    },
    {
      id:11,
      name:'Photocard Period SetUp',
      path:"photocard-period-setup",
      color:"#967BB6"
    },
    {
      id:12,
      name:'Exam Instructions Editor',
      path:"exam-instructions-editor",
      color:"#27C7BD"
    },
    {
      id:13,
      name:'Exam TimeTable SetUp',
      path:"exam-time-table",
      color:"#DEA22F"
    },
    {
      id:14,
      name:'Resit Time Table',
      path:"resit-time-table",
      color:"#e60b2b"
    },
    {
      id:14,
      name: 'Transcript Destination Amount SetUp',
      path: "transcript-amount",
      color: "#035752"
    },
    {
      id:15,
      name:'Reschedule Exam',
      path:"reschedule-exam",
      color:'#035752'
    },
    {
      id:16,
      name:'Reset Student Password',
      path:"reset-user",
      color:"#e60b2b"
    },
    
  {
    id:17,
    name:'Suspend Student',
    path:"suspend",
    color:"#e60b2b"
  },
  {
    id:18,
    name: 'Upgrade Subjects Scores ',
    path: "upgrade-score",
    color: "#035752"
  },
  
    {
      id:19,
      name: 'Migrate Student to Membership',
      path: "student-migration",
      color: "#035752"
    },
    {
      id:20,
      name:'Withhold/Unwithold Exam',
      path:"withold-exam",
      color:"#e60b2b"
    },
    {
      id:21,
      name: 'Restore Deleted TimeTable',
      path: "deleted-time-table",
      color: "#035752"
    },
 
 
    {
      id:9,
      name:'Exam SubjectFee setup',
      path:"fee-setup",
      color:"#DEA22F"
    },
    {
      id:22,
      name:'Permission Setup',
      path:"Permission-setup",
      color:"#27C7BD"
    },
     {
      id:23,
      name:'Role Permission',
      path:"role-permission",
      color:"#DEA22F"
    },
  
    {
      id:24,
      name:'Subscription SetUp',
      path:"subscription-set-up",
      color:"#035752"
    },
     {
      id:24,
      name:'Edit Transcript Template',
      path:"transcript-template-update",
      color:"#DEA22F"
    },
 


  ]
  return <Box w="100%">
    <TopDisplay label="Settings" />
    <Grid templateColumns="repeat(2,43%)" mt="35px" gap="20px" justifyContent="space-between">
      {settings_list.map(({id,name,path,color}:ListType) =>
        <GridItem as={Link} to={"/settings/"+path} key={id}>
          <Card as={Flex} boxShadow="none" border="1px solid var(--green-border-color)" bg="transparent" flexDir={"row"} gap="20px" alignItems="center" w="100%" p="15px" borderRadius="5px">
            <Circle size="45px" bg={color||'blue'}>
              <Image
                src="/public-assets/setting.png"
                objectFit="contain"
                objectPosition="center"
                w="25px"
                h="25px"
              />
            </Circle>
            <Box fontSize="1.05rem" mr="auto" fontWeight="500">{name}</Box>
            <RightIcon/>
           
          </Card>
          
          
        </GridItem>

      )}
    </Grid>
  </Box>
}